import { useSnapshot } from 'valtio';

import { appStore } from '@/store';

function useFormatters() {
  const snap = useSnapshot(appStore);
  const { locale, currency } = snap;

  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: 0,
  });

  const floatFormat = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: 1,
  });

  const currencyFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
  });

  const percentFormat = new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: 1,
  });

  // const kgFormat = new Intl.NumberFormat(locale, {
  //   style: 'unit',
  //   unit: 'kilogram',
  // });

  return {
    formatNumber: (value: number) => numberFormat.format(value),
    formatFloat: (value: number) => floatFormat.format(value),
    formatCurrency: (value: number) => currencyFormat.format(value),
    formatPercent: (value: number) => percentFormat.format(value),
    // formatKg: (value: number) => kgFormat.format(value),
  };
}

export { useFormatters };
